import { MENU } from '../constants'
import { slideActions } from './index'
import store from '../store'
import { viewsActions } from './viewsActions'
// import { getStyleConvertedToMobile } from '../modules/Utils/functions'
import { convertCaptionToMobile } from '../../Utils/utils'
import { ResponciveModule } from '../../Utils/responsiveModule'
import { getDiff } from '../api/converter'

const menuActions = {

    previewSlide() {
        return {
            type: MENU.PREVIEW_SLIDE,
        }
    },

    stopPreview() {
        return {
            type: MENU.STOP_PREVIEW,
        }
    },

    switchEditingTextPanel(newBoolean) {
        return {
            type: MENU.SWITCH_EDIT_TEXT_PANEL,
            payload: newBoolean
        }
    },

    shiftIsPress(boolean) {
        return {
            type: MENU.SHIFT_PRESS,
            payload: boolean,
        }
    },

    ctrlIsPress(boolean) {
        return {
            type: MENU.CTRL_PRESS,
            payload: boolean,
        }
    },

    addSelectedCaption(captionIndex) {
        return {
            type: MENU.ADD_SELECTED_CAPTION,
            payload: captionIndex,
        }
    },

    chooseAnotherOneCaption(captionIndex) {
        return {
            type: MENU.CHOOSE_ANOTHER_ONE_CAPTION,
            payload: captionIndex,
        }
    },

    unselectCaption(selectedIndex, isLayersOrder) {
        const captions = store.getState().menuReducer.captionSelectedArray
        let indexInArray = captions.findIndex(index => index === selectedIndex)
        if (captions.length <= 1 && !isLayersOrder) {
            store.dispatch(viewsActions.backToMainMenu())
        }
        return {
            type: MENU.UNSELECT_CAPTION,
            payload: indexInArray,
        }
    },

    addAllCaptions() {
        const captions = store.getState().slideReducer.captions
        let captionsIndex = []
        captions.map((caption, index) => {
            if (caption.boxId === '') {
                captionsIndex.push(index)
            }
        })
        return {
            type: MENU.ADD_ALL_CAPTIONS,
            payload: captionsIndex,
        }
    },

    addSomeCaptions(captionsIndex) {
        return {
            type: MENU.ADD_SOME_CAPTIONS,
            payload: captionsIndex,
        }
    },


    copyCaptions() {
        const captionSelectedArray = store.getState().menuReducer.captionSelectedArray
        const captions = store.getState().slideReducer.captions
        // const workspace = document.querySelector('#workspace').getBoundingClientRect()
        // console.log('workspace',workspace);
        // let copyCaptions = captions.filter(caption => captionSelectedArray.includes(caption.index))
        let copyCaptions = []
        captionSelectedArray.map((index, indexInSelectedArray) => {
            let copyCaption = _.cloneDeep(captions[index])
            // copyCaption.id = `id-${Date.now() + parseInt(Math.random() * 1000)}`
            // copyCaption.position.x += 20
            // copyCaption.position.y += 20
            // copyCaption.index = captions.length + indexInSelectedArray
            // console.log('copyCaption',copyCaption);
            // if (copyCaption.position.y + 20 < workspace.bottom)

            copyCaptions.push(copyCaption)
        })

        return {
            type: MENU.COPY_CAPTIONS,
            payload: { copyCaptions, allCaptions: captions },
        }
    },

    clearSelectedCaption() {
        return {
            type: MENU.CLEAR_SELECTED_CAPTION,
        }
    },

    changeGrid(newBoolean) {
        return {
            type: MENU.CHANGE_GRID,
            payload: newBoolean
        }
    },

    initSavedRulers() {
        let slide = JSON.parse(sessionStorage.getItem('editing-slide')) || { rulers: { rulersArray: [], rulersArrayMobile: [] } }
        let currentRulers = slide.currentRulers || slide.rulers.rulersArray
        let currentRulersMobile = slide.currentRulersMobile || slide.rulers.rulersArrayMobile
        return {
            type: MENU.INIT_SAVED_RULERS,
            payload: { rulersArray: currentRulers, rulersArrayMobile: currentRulersMobile }
        }
    },
    changeRulers(newBoolean) {
        return {
            type: MENU.CHANGE_RULERS,
            payload: newBoolean
        }
    },

    addRuler(newRuler) {
        return {
            type: MENU.ADD_RULER,
            payload: newRuler,
        }
    },

    deleteRuler(rulerId) {
        return {
            type: MENU.DELETE_RULER,
            payload: rulerId,
        }
    },

    changeRulerPosition(rulerId, newPosition) {
        return {
            type: MENU.CHANGE_RULER_POSITION,
            payload: { id: rulerId, position: newPosition },
        }
    },

    changeViewType(newType) {
        // const needMobileConvert = store.getState().slideReducer.needMobileConvert;
        // console.log('needMobileConvert',needMobileConvert);
        // if ((needMobileConvert === true || needMobileConvert === undefined) && newType === 'mobile') {
        const slide = _.cloneDeep(store.getState().slideReducer);
        const mobileViewScale = newType === 'mobile' ? 1 : store.getState().menuReducer.mobileViewScale / 100;
        // const widthProp = newType === 'mobile' ? 'width' : 'mobileWidth'
        const heightProp = newType === 'mobile' ? 'height' : 'mobileHeight'
        let needToUpdateSettings = false


        slide.captions = slide.captions.map(caption => {
            const captionElem = document.getElementById(`caption-${caption.index}`)
            if (captionElem && (caption.type === 'text' || caption.type === 'button')) {
                // caption[widthProp] = captionElem.getBoundingClientRect().width / mobileViewScale
                caption[heightProp] = captionElem.getBoundingClientRect().height / mobileViewScale
                needToUpdateSettings = true
            }
            return caption
        })
        if (newType === 'mobile') {
            // для размера шрифта и зависящих от него параметров нужно отношение реальных размеров виджета к размеру в редакторе
            const editorDiff = getDiff(slide.widgetData.originalWidth, slide.widgetData.originalHeight)

            const rm = new ResponciveModule(
                slide.widgetData.mobileWidth,
                slide.widgetData.mobileHeight,
                slide.widgetData.width,
                slide.widgetData.height,
            );
            // console.log('view type mobile')
            // const {captions, someCaptionWasConverted} = rm.convertSlideCaptionsToMobile(slide.captions, editorDiff)
            // slide.captions = captions
            // needToUpdateSettings = someCaptionWasConverted ? true : needToUpdateSettings
            slide.captions.map((caption, captionIndex, captionsArray) => {
                //     // если капчу создали, но ни разу её не редактировали в мобильном виде,
                //     // то адаптируем её по образу и подобию десктопной капчи
                if (caption.needMobileConvert === true) {
                    caption.needMobileConvertOnlyPosition = true
                    caption = rm.convertCaptionToMobile(caption, captionsArray, editorDiff);
                    //         // caption = convertCaptionToMobile(caption, diffW, diffH)
                    if (caption.version < 2 || caption.version === undefined) {
                        caption.version = 2
                        // old captions before update always have this properties
                        if (caption.mobilePosition) {
                            if (caption.mobileBorderRadius !== undefined) delete caption.mobileBorderRadius
                            if (caption.mobilePadding !== undefined) delete caption.mobilePadding
                            if (caption.mobileBorderWidth !== undefined) delete caption.mobileBorderWidth
                            if (caption.mobileFontSize !== undefined) delete caption.mobileFontSize
                            if (caption.mobileLineHeight !== undefined) delete caption.mobileLineHeight
                            if (caption.mobileLetterSpacing !== undefined) delete caption.mobileLetterSpacing
                        }
                        
                    }
                    // delete caption.needMobileConvert
                    // if (caption.mobileBorderRadius !== undefined) delete caption.mobileBorderRadius
                    // if (caption.mobilePadding !== undefined) delete caption.mobilePadding
                    // if (caption.mobileBorderWidth !== undefined) delete caption.mobileBorderWidth
                    // if (caption.mobilePosition !== undefined) delete caption.mobilePosition
                    // if (caption.mobileFontSize !== undefined) delete caption.mobileFontSize
                    // if (caption.mobileLineHeight !== undefined) delete caption.mobileLineHeight
                    // if (caption.mobileLetterSpacing !== undefined) delete caption.mobileLetterSpacing
                    // if (caption.mobileWidth !== undefined) delete caption.mobileWidth
                    // if (caption.mobileHeight !== undefined) delete caption.mobileHeight

                    if (caption.needMobileConvertOnlyPosition !== undefined) delete caption.needMobileConvertOnlyPosition
                    caption.captionRandomKey = Date.now() + parseInt(Math.random() * 1000)
                    //         someCaptionWasConverted = true
                }
            })
        }
        // если какая либо капча была конвертирована - сохраняем это
        if (needToUpdateSettings) {
            store.dispatch(slideActions.updateSlideSettings(slide))
        }
        // store.dispatch(slideActions.updateSlideSettings(slide))
        store.dispatch(viewsActions.backToMainMenu())

        return {
            type: MENU.CHANGE_VIEW_TYPE,
            payload: newType,
        }
    },

    changeEditingCaptionIndex(index) {
        return {
            type: MENU.CHANGE_EDITING_CAPTION_INDEX,
            payload: index,
        }
    },

    openFontPicker(newVal) {
        newVal === undefined ? newVal = !store.getState().menuReducer.fontPickerIsOpen : {}
        return {
            type: MENU.OPEN_FONT_PICKER,
            payload: newVal
        }
    },
    openShadowPicker(newVal) {
        newVal === undefined ? newVal = !store.getState().menuReducer.shadowPickerIsOpen : {}
        return {
            type: MENU.OPEN_SHADOW_PICKER,
            payload: newVal
        }
    },

    changeFontPickerPosition(data) {
        const newPosition = {
            x: data.lastX,
            y: data.lastY,
        }
        return {
            type: MENU.CHANGE_FONT_PICKER_POSITION,
            payload: newPosition
        }
    },
    changeShadowPickerPosition(data) {
        const newPosition = {
            x: data.lastX,
            y: data.lastY,
        }
        return {
            type: MENU.CHANGE_SHADOW_PICKER_POSITION,
            payload: newPosition
        }
    },

    changeBoxFigureIsEdit(newVal) {
        if (newVal === undefined) {
            const currentVal = store.getState().menuReducer.boxFigureIsEdit
            newVal = !currentVal
        }

        // if(newVal === false){
        //     store.dispatch(slideActions.changeBoxEditingDimesions())
        // }

        return {
            type: MENU.CHANGE_BOX_FIGURE_IS_EDIT,
            payload: newVal
        }
    },

    changePipett(newVal) {
        if (newVal === undefined) {
            const currentVal = store.getState().menuReducer.boxFigureIsEdit
            newVal = !currentVal
        }

        return {
            type: MENU.CHANGE_PIPETT,
            payload: newVal
        }
    },

    changeMobileViewScale(newVal) {
        return {
            type: MENU.CHANGE_MOBILE_VIEW_SCALE,
            payload: newVal
        }
    },

    updateWorkspaceRandom() {
        return {
            type: MENU.UPDATE_WORKSPACE_RANDOM,
        }
    },

    setUnicClassName(newVal) {
        return {
            type: MENU.SET_UNIC_CLASSNAME,
            payload: newVal
        }
    },

    saveTempStyle(caption) {
        return {
            type: MENU.SAVE_TEMP_STYLE,
            payload: caption
        }
    },

    toggleImageCrop(bool) {
        return {
            type: MENU.TOGGLE_IMAGE_CROP,
            payload: bool
        }
    },

    videoTutorialActive() {
        return {
            type: MENU.VIDEO_TUTORIAL_ACTIVE
        }
    },

    toggleEditingText() {
        return {
            type: "TOGGLE_EDITING_TEXT"
        }
    },
    dropdownIsOpen(bool) {
        return {
            type: MENU.DROPDOWN_IS_OPEN,
            payload: bool
        }
    },
    toggleIconModal() {
        return {
            type: MENU.TOGGLE_ICON_MODAL
        }
    },
    toggleSVGModal() {
        return {
            type: MENU.TOGGLE_SVG_MODAL
        }
    },
    imageCaptionCropToggle(index) {
        return {
            type: MENU.IMAGE_CAPTION_CROP,
            payload: index
        }
    },

}

export { menuActions }